import { useMutation } from '@apollo/client';
import type { DeleteUserGroupUsersMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteUserGroupUsersDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteUserGroupUsersTRPC } from './useDeleteUserGroupUsersTRPC';

type DeleteUserGroupUsersInput = {
  UserIds: string[];
  UserGroupId: string;
};

export const useDeleteUserGroupUsers = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [deleteGraphQL, graphqlState] = useMutation(
    DeleteUserGroupUsersDocument,
    {
      update: (cache) => {
        evictField(cache, 'user_group_user');
      },
    }
  );

  const trpcMutation = useDeleteUserGroupUsersTRPC();

  const deleteUserGroupUsers = async (
    variables: DeleteUserGroupUsersInput
  ): Promise<DeleteUserGroupUsersMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteUserGroupUsers(variables);
    }

    const result = await deleteGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to remove users from group');
    }

    return result.data;
  };

  return {
    deleteUserGroupUsers,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
